export const identifyUser = async ({ user, hash, ...props }) => {
  if (window.analytics && (user || hash)) {
    const { createDate, id, email } = user || {}
    let userId = id
    let userEmail = email
    // if there is no id from the user, we can get the user's id from the /identify endpoint
    if (!id) {
      const response = await fetch(`/api/account/identify`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          email,
          hash,
        }),
        headers: {
          "Content-Type": "application/json",
          "X-API-LANGUAGE": "en/us", // this is a spam header that is required by the API
        },
      })
      if (!response.ok) {
        console.log(response.statusText)
        return
      }
      const mbgUser = await response.json()
      if (mbgUser.id) {
        ;({ id: userId, email: userEmail } = mbgUser)
      }
    }
    if (userId) {
      const identifyPayload = {
        email: userEmail,
        ...(createDate && { createdAt: createDate }),
        ...(props && { ...props }),
      }
      window.analytics.identify(userId, identifyPayload)
    }
  }
}
